<template>
  <BasicLayout>
    <template #wrapper>
      <el-tabs tab-position="left" style="background-color: #ffffff;height: 100%" @tab-click="handleTapClick">
        <el-tab-pane label="兑换码配置" name="0">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <el-button v-permisaction="['config:exchange:add']" type="primary" size="mini" style="margin-left: 16px;" @click="add(0)">新增</el-button>
            </div>
            <template>
              <el-table :data="tableData" border style="width: 100%">
                <el-table-column prop="code" label="兑换码" width="150px" align="center" />
                <el-table-column prop="limit" label="可领取数量" align="center" />
                <el-table-column prop="rwdNum" label="已领奖人数" width="150" align="center" />
                <el-table-column prop="status" label="状态" align="center" :formatter="statusFormatter" />
                <el-table-column prop="usertype" label="可领用户类型" align="center" width="200px" :formatter="userTypeFormatter" />
                <el-table-column prop="time" label="创建时间" align="center" width="160px" />
                <el-table-column prop="rwd" label="奖励" width="180px" align="center" :formatter="rwdFormatter" />
                <el-table-column prop="expire" label="过期时间" width="160px" align="center" />
                <!--                <el-table-column prop="random_reward" label="随机奖励" align="center" :formatter="randomRewardFormatter"/>-->
                <el-table-column prop="userLimit" label="限定用户" align="center" :formatter="userLimitFormatter" />
                <el-table-column prop="remake" label="备注" align="center" />
                <el-table-column fixed="right" label="操作" width="100">
                  <template slot-scope="scope">
                    <el-button v-permisaction="['config:exchange:edit']" type="text" size="small" @click="edit(scope.row)">编辑</el-button>
                    <el-button v-permisaction="['config:exchange:edit']" type="text" size="small" @click="copyCode(scope.row.code)">拷贝</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <pagination v-show="total>0" background :page.sync="queryParams.pageIndex" :limit.sync="queryParams.pageSize" :total="total" @pagination="getTables" />
            </template>
          </el-card>
        </el-tab-pane>
        <el-tab-pane label="短链配置" name="1">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <el-button v-permisaction="['config:exchange:add']" type="primary" size="mini" style="margin-left: 16px;" @click="add(1)">新增</el-button>
            </div>
            <template>
              <el-table :data="tableData" border style="width: 100%">
                <el-table-column label="短链" align="center">
                  <template slot-scope="scope">
                    <a :href="scope.row.shortUrl" target="_blank">{{ scope.row.shortUrl }} </a>
                  </template>
                </el-table-column>
                <el-table-column label="原始链接" align="center">
                  <template slot-scope="scope">
                    <a :href="scope.row.origUrl" target="_blank">{{ scope.row.origUrl }} </a>
                  </template>
                </el-table-column>
                <el-table-column prop="limit" label="可领取数量" width="90" align="center" />
                <el-table-column prop="rwdNum" label="已领奖人数" width="90" align="center" />
                <el-table-column prop="status" label="状态" align="center" width="80" :formatter="statusFormatter" />
                <el-table-column prop="usertype" label="可领用户类型" align="center" width="100px" :formatter="userTypeFormatter" />
                <el-table-column prop="rwd" label="奖励" width="180px" align="center" :formatter="rwdFormatter" />
                <el-table-column prop="userLimit" label="限定用户" align="center" :formatter="userLimitFormatter" />
                <el-table-column prop="remake" label="备注" align="center" />
                <el-table-column prop="time" label="创建时间" align="center" width="160px" />
                <el-table-column prop="expire" label="过期时间" width="160px" align="center" />
                <!--                <el-table-column prop="random_reward" label="随机奖励" align="center" :formatter="randomRewardFormatter"/>-->
                <el-table-column fixed="right" label="操作" width="100">
                  <template slot-scope="scope">
                    <el-button v-permisaction="['config:exchange:edit']" type="text" size="small" @click="edit(scope.row)">编辑</el-button>
                    <el-button v-permisaction="['config:exchange:edit']" type="text" size="small" @click="copyCode(scope.row.code)">拷贝</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <pagination v-show="total>0" background :page.sync="queryParams.pageIndex" :limit.sync="queryParams.pageSize" :total="total" @pagination="getTables" />
            </template>
          </el-card>
        </el-tab-pane>
      </el-tabs>

      <el-drawer title="配置" :visible.sync="drawer" size="1000px" :before-close="handleClose">
        <el-form ref="formData" :rules="rules" :model="formData" label-width="100px">
          <el-form-item v-if="formData.origUrl !== ''" label="原始链接" prop="origUrl" style="width: 600px;">
            <el-input v-model="formData.origUrl" :readonly="true" placeholder="兑换码" />
          </el-form-item>
          <el-form-item v-if="formData.shortUrl !== ''" label="短链" prop="shortUrl" style="width: 600px;">
            <el-input v-model="formData.shortUrl" :readonly="true" placeholder="兑换码" />
          </el-form-item>
          <el-form-item label="兑换码" prop="code" style="width: 600px;">
            <el-input v-model="formData.code" :readonly="formData.id > 0" placeholder="兑换码" />
            <span v-if="formData.id <=0 " style="margin-top: 5px" class="el-icon-info">留空自动生成</span>
          </el-form-item>
          <el-form-item label="生成数量" prop="code" style="width: 400px;">
            <el-input v-model.number="num" placeholder="生成数量" />
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select v-model.number="formData.status" placeholder="请选择">
              <el-option v-for="item in statusType" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="可领取数量" prop="limit" style="width: 400px;">
            <el-input v-model.number="formData.limit" placeholder="可领取数量" />
          </el-form-item>
          <el-form-item label="过期时间" prop="expire">
            <el-date-picker v-model.trim="formData.expire" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" />
          </el-form-item>
          <el-form-item label="领取用户类型" prop="usertype">
            <el-select v-model.number="formData.usertype" placeholder="请选择">
              <el-option v-for="item in userType" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <!--          <el-form-item label="随机奖励" prop="random_reward">-->
          <!--            <el-select v-model.number="formData.random_reward" placeholder="请选择">-->
          <!--              <el-option v-for="item in rewardType" :key="item.value" :label="item.label" :value="item.value"/>-->
          <!--            </el-select>-->
          <!--          </el-form-item>-->
          <el-form-item label="指定用户" prop="userLimit">
            <el-select v-model="formData.userLimit" multiple filterable remote reserve-keyword placeholder="请输入用户ID" :remote-method="remoteMethod" :loading="loading" style="width: 400px">
              <el-option v-for="item in users" :key="item.uid" :label="item.uid" :value="item.uid" />
            </el-select>
            <CommonExcel ref="CommonExcelRef2" :import-method="importCfg" :export-show="false" />
          </el-form-item>
          <el-form-item label="备注" prop="remake" style="width: 400px">
            <el-input v-model="formData.remake" placeholder="备注" />
          </el-form-item>
          <!--          <el-form-item label="奖励">-->
          <!--            <el-form :inline="true">-->
          <!--              <el-form-item label="金币数量" prop="coins">-->
          <!--                <el-input v-model.number="formData.rwd.coins" style="width: 150px" />-->
          <!--              </el-form-item>-->
          <!--              <el-form-item label="体力数量" prop="spins">-->
          <!--                <el-input v-model.number="formData.rwd.spins" style="width: 150px" />-->
          <!--              </el-form-item>-->
          <!--            </el-form>-->
          <!--          </el-form-item>-->
          <el-form-item label="奖励" style="width: 100%">
            <el-form :inline="true">
              <Reward :value="formData.rwd.props" :drawer="false" />
            </el-form>
          </el-form-item>
          <el-form-item style="width:100%;margin-top:50px;text-align: center">
            <el-button type="primary" @click="onSubmit()">保存</el-button>
          </el-form-item>
        </el-form>
      </el-drawer>
    </template>
  </BasicLayout>
</template>

<script>
import { getRewardType } from '@/api/config/slot'
import { searchUid } from '@/api/user/user_info'
import { getExchangeCodeList, getExchangeCodeUrlList, updateExchangeCodeCfg } from '@/api/config/exchange-code-cfg'
import Reward from '@/components/Reward/index.vue'
import CommonExcel from '@/components/CommonExcel/index.vue'

export default {
  name: 'ExchangeCode',
  components: { CommonExcel, Reward },
  data() {
    return {
      num: 1,
      total: 0,
      rewardTypes: [],
      tableData: [],
      loading: false,
      drawer: false,
      queryParams: {
        Type: 0,
        pageIndex: 1,
        pageSize: 10
      },
      copyUrl: '',
      statusType: [{ label: '可领奖', value: 0 }, { label: '已领完', value: 1 }, { label: '已过期', value: 2 }],
      userType: [{ label: '所有', value: 0 }, { label: 'fb', value: 1 }, { label: '游客', value: 2 }],
      rewardType: [{ label: '不随机', value: 0 }, { label: '随机', value: 1 }],
      formDataBak: {},
      formData: {
        id: 0,
        code: '',
        rwd: { spins: 0, coins: 0, props: [] },
        rwdNum: 0,
        status: 0,
        limit: 1,
        expire: '',
        usertype: 0,
        time: 0,
        random_reward: 0,
        remake: '',
        userLimit: [],
        type: 0,
        shortUrl: '',
        origUrl: ''
      },
      users: [],
      rules: {
        limit: [{ required: true, message: '请输入可领取数量', trigger: 'blur' }],
        expire: [{ required: true, message: '请选择过期时间', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.formDataBak = JSON.parse(JSON.stringify(this.formData))
    this.getCopyUrl()
    this.getRewardTypeData()
    this.getTables()
  },
  methods: {
    handleClose(d) {
      this.drawer = false
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        this.rewardTypes = res.data
      })
    },
    getCopyUrl() {
      getExchangeCodeUrlList().then(res => {
        this.copyUrl = res.data
      })
    },
    copyCode(code) {
      const url = this.copyUrl
      const text = `${url}/?code=${code}`
      const m = this
      navigator.clipboard.writeText(text).then(function() {
        m.msgSuccess('复制成功')
      }, function(err) {
        m.msgError('复制失败: ' + err)
      })
    },
    edit(row) {
      this.formData = row
      this.drawer = true
    },
    addReward() {
      this.formData.rwd.props.push({ propsId: '', num: 1 })
    },
    delReward(i) {
      this.formData.rwd.props = this.formData.rwd.props.filter((item, index) => {
        return index !== i
      })
    },
    onSubmit() {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          const _data = this.formData
          if (this.num <= 0) {
            this.msgError('至少生成一个')
            return
          }
          if (_data.code && _data.code.length < 4) {
            this.msgError('兑换码最少4个长度')
            return
          }
          if (_data.limit <= 0) {
            this.msgError('可领取数量不能小于0')
            return
          }

          for (const i in _data.rwd.props) {
            const prop = _data.rwd.props[i]
            if (!prop.propsId) {
              this.msgError('请选择道具ID')
              return
            }
          }

          const data = JSON.stringify(this.formData)
          updateExchangeCodeCfg({ id: this.num, data: data }).then(res => {
            this.num = 1
            this.formData = JSON.parse(JSON.stringify(this.formDataBak))
            this.getTables()
            this.drawer = false
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getTables() {
      this.tableData = []
      this.loading = true
      getExchangeCodeList(this.queryParams).then(res => {
        res.data.list.forEach((item, index) => {
          if (item.rwd.props === null) {
            res.data.list[index].rwd.props = []
          }
        })
        this.tableData = res.data.list
        this.total = res.data.count
        this.loading = false
      })
    },
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true
        searchUid({ id: query }).then(res => {
          this.loading = false
          this.users = res.data.data
        })
      } else {
        this.users = []
      }
    },
    add(type) {
      this.formDataBak.type = type
      this.formData = JSON.parse(JSON.stringify(this.formDataBak))
      this.drawer = true
    },
    del(index) {
      this.formData = this.formData.filter((item, key) => {
        return index !== key
      })
    },
    statusFormatter(row, col) {
      let statusText = ''
      for (const i in this.statusType) {
        const val = this.statusType[i]
        if (val.value === row.status) {
          statusText = val.label
          break
        }
      }
      return statusText
    },
    userTypeFormatter(row, col) {
      let userTypeText = ''
      for (const i in this.userType) {
        const val = this.userType[i]
        if (val.value === row.status) {
          userTypeText = val.label
          break
        }
      }
      return userTypeText
    },
    randomRewardFormatter(row, col) {
      let randomRewardText = ''
      for (const i in this.rewardType) {
        const val = this.rewardType[i]
        if (val.value === row.status) {
          randomRewardText = val.label
          break
        }
      }
      return randomRewardText
    },
    rwdFormatter(row, col) {
      let text = ''
      if (row.rwd.coins > 0) {
        text += ' 金币 * ' + row.rwd.coins
      }

      if (row.rwd.spins > 0) {
        text += ' 体力 * ' + row.rwd.spins
      }

      if (row.rwd.props) {
        row.rwd.props.forEach(item => {
          if (item.num > 0) {
            text += this.rewardTypes[item.propsId] + ' * ' + item.num
          }
        })
      }

      return text
    },
    userLimitFormatter(row, col) {
      if (row.userLimit.length > 5) {
        return '用户过多,不显示'
      }
      let text = ''
      row.userLimit.forEach(item => {
        text += item + ','
      })
      return text
    },
    handleTapClick(val) {
      this.queryParams.Type = Number(val.name)
      this.getTables()
    },
    importCfg(updateInfo) {
      const excelData = updateInfo.data
      for (let i = 0; i < excelData.length; i++) {
        // const sheet = excelData[i].sheetName
        // const editFlag = false
        const uidData = excelData[i].sheetData
        const uids = []
        for (const i in uidData) {
          const val = uidData[i]
          uids.push(val['用户ID'])
        }
        this.formData.userLimit = uids
      }
    }
  }
}
</script>

<style scoped>
</style>
